import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import FormField from "../../forms/fields/FormField";
import errorToast from "../../components/toast/ErrorToast";
import {default as handleSuccessToast} from "../../components/toast/SuccessToast";
import SaporeForm from "../../forms/SaporeForm";
import {CUSTOMER_ONBOARDINGS_PATH} from "../../routes";
import TextField from "../../forms/fields/TextField";


export default class CreateCustomerOnboardingFeature {
    constructor(application, navigator) {
        this._application = application;
        this._navigator = navigator;
        this._loaded = false;
        this._form = null;
        this._customerOnboarding = null

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            form: computed,
            _form: observable,
            isFormValid: computed,
            _finishLoading: action
        })
    }

    async load() {
        this._createForm()
        this._finishLoading()
    }

    _createForm() {
        const fields = {
            "cuit": new TextField(11, 11, false, null, this),
        }
        this.form = new SaporeForm(fields);
    }

    async createCustomerOnboarding() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async (response) => {
                this._customerOnboarding = response.customerOnboarding()
                handleSuccessToast('Alta de cliente iniciada éxito')
                this._navigator(CUSTOMER_ONBOARDINGS_PATH)
            },
            handlesError: (response) => {
                if (response.hasError()) {
                    const error_code = response.errors()[0].code
                    if (error_code === 'customer_onboarding_customer_already_exists'){
                        errorToast('Ya existe un cliente con este CUIT')
                    }
                    else if (error_code === 'duplicated_taxpayer_identification_number'){
                        errorToast('Ya existe un alta de cliente abierta con el CUIT ingresado')
                    }
                    else if (error_code === 'inactive_taxpayer_identification_number'){
                        errorToast('El CUIT ingresado no es válido para ARCA')
                    }
                    else if (error_code === 'arca_unavailable'){
                        errorToast('ARCA no responde, intentá dar de alta el cliente más tarde')
                    }
                    else {
                        errorToast('Ha ocurrido un error al crear el alta de cliente.')
                    }
                }
            }
        });
        const taxpayerIdentificationNumber = this.taxpayerIdentificationNumber();
        return this._application.apiClient().createCustomerOnboarding(responseHandler, taxpayerIdentificationNumber);
    }

    taxpayerIdentificationNumber() {
        return this.form.values.cuit;
    }

    get isFormValid() {
        return this.form.isValid;
    }

    get form() {
        return this._form;
    }

    set form(newForm) {
        this._form = newForm;
    }

    get loaded() {
        return this._loaded;
    }

    _finishLoading() {
        this._loaded = true;
    }
}